module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Space Gray Aluminum + Black Cool Gray Nike Open.fd4bc20f.png";